import React from "react";
import classes from "./StudentAttendanceTable.module.css";
import defaultAvatar from "../../assets/default-avatar.png";
import FilterIcon from '../../assets/icons/filter-icon-blue.svg';
import FilterDropDown from "../UI/FilterDropDown/FilterDropDown";

export default function StudentAttendanceTable(props) {
    const data = props.data;
    const columnData = props.columnData;

    return (
        <div className={classes.StudentTableContainer}>
            <div className={classes.Table2Container}>
                <table className={classes.TableStyle2}>
                    <thead className={classes.TableHeading}>
                        <tr className={classes.TableRowHeading}>
                            <th className={[classes.Head1, classes.Head1Width].join(' ')}>
                                <div className={classes.CenterAlignTh}>
                                    {props.tableHead1}
                                    <img src={FilterIcon} onClick={props.onNameFilterClicked} alt={props.tableHead1 + ' filter sort icon'} className={classes.FilterIcon} />
                                    {props.showNameFilterDropdown
                                        ? <div className={classes.Dropdown}>
                                            <FilterDropDown
                                                itemList={props.nameDropDownItems}
                                                onDropDownClicked={props.onNameFilterClicked}
                                                onDropDownItemClicked={props.onDropDownItemClicked}
                                                activeItem={props.activeNameDropdownItem}
                                                searchFieldValue={props.nameSearchFieldValue}
                                                inputChangeHandler={props.nameSearchInputChangeHandler}
                                                onSearchIconClick={props.onNameSearchIconClick}
                                                clearSearchResults={props.clearSearchResults}
                                                searchString={props.searchString}
                                                forNumber={false}
                                            />
                                        </div>
                                        : null}
                                </div>
                            </th>
                            <th className={[classes.Head2, classes.Head2Width].join(' ')}>
                                <div className={[classes.CenterAlignTh, classes.AttendanceDiv].join(' ')}>
                                    {props.tableHead2} <br />(%)
                                    <img src={FilterIcon} onClick={props.onAttendanceFilterClicked} alt={props.tableHead2 + ' filter sort icon'} className={classes.FilterIcon} />
                                    {props.showAttendanceFilterDropdown
                                        ? <div className={[classes.Dropdown, classes.AttendanceDropdown].join(' ')}>
                                            <FilterDropDown
                                                itemList={props.attendanceDropDownItems}
                                                onDropDownClicked={props.onAttendanceFilterClicked}
                                                onDropDownItemClicked={props.onDropDownItemClicked}
                                                activeItem={props.activeAttendanceDropdownItem}
                                                searchFieldValue={props.nameSearchFieldValue}
                                                inputChangeHandler={props.nameSearchInputChangeHandler}
                                                onSearchIconClick={props.onNameSearchIconClick}
                                                forNumber={true}
                                            />
                                        </div>
                                        : null}
                                </div>
                            </th>
                            {columnData.slice(0, props.viewAll ? columnData.length : 1).map((item, index) => (
                                <th key={index}
                                    className={[classes.Head3, classes.SmallWidth].join(" ")}>
                                    <div className={classes.DueText}>
                                        <span>{item.weekName}</span>:{item.from} - {item.to}
                                    </div>
                                    <div className={classes.DescText}>
                                        <div>
                                            <div>
                                                {item.sessionsConducted}/{item.totalSessions}
                                            </div>
                                            <div className={classes.SubText}>
                                                Sessions Conducted
                                            </div>
                                        </div>
                                        <div>
                                            <div>{item.uniqueStudents}</div>
                                            <div className={classes.SubText}>Unique Students</div>
                                        </div>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <thead className={classes.ColumnHeading}>
                        <tr className={classes.SubHeadingRow}>
                            <th className={classes.Column1}>{props.colHead1}</th>
                            <th className={classes.Column2}>
                                <div className={classes.SubHeadingData}>
                                    {`${props.colHead2} %`}
                                </div>
                            </th>

                            {columnData.slice(0, props.viewAll ? columnData.length : 1).map((item, index) => {
                                return (
                                    <th className={classes.Column3} key={index}>
                                        <div className={classes.WeekDayHeading}>
                                            <div className={classes.WeekDaysStyle}>Mo
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[0] != null ? item.attendance[0] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>Tu
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[1] != null ? item.attendance[1] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>We
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[2] != null ? item.attendance[2] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>Th
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[3] != null ? item.attendance[3] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>Fr
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[4] != null ? item.attendance[4] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>Sa
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[5] != null ? item.attendance[5] : "-"}</p>
                                            </div>
                                            <div className={classes.WeekDaysStyle}>Su
                                                <p className={classes.NumberStyle}>
                                                    {item.attendance[6] != null ? item.attendance[6] : "-"}</p>
                                            </div>
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => {
                            return (
                                <tr key={index} className={classes.TableRow}>
                                    <td>
                                        <div className={classes.StudentNameData}>
                                            <img
                                                src={row.profilePic ? row.profilePic : defaultAvatar}
                                                alt="user-profile-pic"
                                                className={classes.ProfilePic}
                                            />
                                            <span>{row.name}</span>
                                        </div>
                                    </td>
                                    <td className={classes.RowColumn2}><div className={classes.OverallGrade}>{row.overallGrade} %</div></td>
                                    {row.weeks.slice(0, props.viewAll ? row.weeks.length : 1).map((week, pos) => {
                                        return (
                                            <td key={pos} className={classes.TableData}>
                                                <div className={classes.WeekDayData}>
                                                    {week.weekAttendance.map((day, num) => {
                                                        return (
                                                            <div key={num} className={classes.WeekDays}>
                                                                {day === 'OFF' ? 'OFF' : day === false ? 0 : 1}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
